/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventsviewlist2Inputs */

const en_eventsviewlist2 = /** @type {(inputs: Eventsviewlist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List`)
};

const de_eventsviewlist2 = /** @type {(inputs: Eventsviewlist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste`)
};

/**
* | output |
* | --- |
* | "List" |
*
* @param {Eventsviewlist2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventsviewlist2 = /** @type {((inputs?: Eventsviewlist2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventsviewlist2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventsviewlist2(inputs)
	return de_eventsviewlist2(inputs)
});
export { eventsviewlist2 as "eventsViewList" }